'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var ComponentContainer = function (props) {
    var children = props.children, printRef = props.printRef;
    return (React__default.createElement("div", { "data-testid": 'print-component-container', ref: printRef },
        React__default.createElement(styledComponents.GlobalStyle, null),
        children));
};

exports.ComponentContainer = ComponentContainer;
exports.default = ComponentContainer;
